var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1949 8.84211H13.4285C13.3851 6.18546 11.2627 4.00411 8.50631 3.62813C8.8968 3.35967 9.15493 2.92008 9.15493 2.41881C9.15493 1.61085 8.49408 0.95 7.68612 0.95C6.87816 0.95 6.21732 1.61085 6.21732 2.41881C6.21732 2.91669 6.47223 3.36975 6.86089 3.62882C4.10699 4.00676 1.98717 6.18708 1.94373 8.84211H1.17735C1.11278 8.84211 1.05509 8.86385 1.01342 8.90552C0.971741 8.9472 0.95 9.00489 0.95 9.06946C0.95 9.13403 0.971741 9.19172 1.01342 9.23339C1.05509 9.27507 1.11278 9.29681 1.17735 9.29681H14.1949C14.2595 9.29681 14.3172 9.27507 14.3588 9.23339C14.4005 9.19172 14.4222 9.13403 14.4222 9.06946C14.4222 8.93224 14.3079 8.84211 14.1949 8.84211ZM6.67202 2.41881C6.67202 1.86116 7.12848 1.4047 7.68612 1.4047C8.24376 1.4047 8.70023 1.86116 8.70023 2.41881C8.70023 2.97645 8.24376 3.43291 7.68612 3.43291C7.12848 3.43291 6.67202 2.97645 6.67202 2.41881ZM7.68612 4.02949C10.588 4.02949 12.9276 6.18275 12.9738 8.85984H2.39846C2.44466 6.18275 4.78429 4.02949 7.68612 4.02949Z",
    fill: "#1D1D1B",
    stroke: "black",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1949 10.7752H1.17735C1.11278 10.7752 1.05509 10.7969 1.01342 10.8386C0.971741 10.8803 0.95 10.938 0.95 11.0025C0.95 11.0671 0.971741 11.1248 1.01342 11.1665C1.05509 11.2082 1.11278 11.2299 1.17735 11.2299H14.1949C14.2595 11.2299 14.3172 11.2082 14.3588 11.1665C14.4005 11.1248 14.4222 11.0671 14.4222 11.0025C14.4222 10.8653 14.3079 10.7752 14.1949 10.7752Z",
    fill: "#1D1D1B",
    stroke: "black",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodType);
export default __webpack_public_path__ + "static/media/foodType.cf89a224e85addbd805fada785b72146.svg";
export { ForwardRef as ReactComponent };